import { FC } from "react";
import { SwitchToggleProps } from "./types";

const SwitchToggle: FC<SwitchToggleProps> = ({
  dimensions,
  circlePosition,
  containerClassName,
  circleClassName,
  onClick,
}) => {
  return (
    <div
      style={{
        width: `${dimensions.width}px`,
        height: `${dimensions.height}px`,
      }}
      className={containerClassName}
      onClick={onClick}
    >
      <div
        style={{
          width: `${dimensions.circleSize}px`,
          height: `${dimensions.circleSize}px`,
          right: `${circlePosition}px`,
        }}
        className={circleClassName}
      />
    </div>
  );
};

export default SwitchToggle;
